import update from 'immutability-helper'
import { useCallback, useState, useEffect } from 'react'
import { DNDElement } from './DNDElement.js'

export const DNDContainer = ({cards, setComponents, setSelectedComponentIndex, language = 'en'}) => {
  
    const [pinPosition, setPinPosition] = useState(-1)
    const moveCard = useCallback((dragIndex, hoverIndex) => {
      setComponents((prev) => {
        var comp = update(prev, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prev[dragIndex]],
          ],
        })

        return comp;
      })
    }, [])


    useEffect(() => {
      const index = cards.findIndex(c => c.name === 'pin');
      setPinPosition(index)
    }, [cards])

    return (
      <>
        {cards?.map((card, index) => (
          <DNDElement
            key={card.id}
            index={index}
            id={card.id}
            card={card}
            moveCard={moveCard}
            hidden={pinPosition !== -1 && index > pinPosition}
            language={language}
            setSelectedComponentIndex={setSelectedComponentIndex}
          />
        ))}
      </>
    );
  
}
